import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/system/Box";
import React from "react";
const BIG_IMAGE_HEIGHT = 70;
const SMALL_IMAGE_HEIGHT = 24;
const eagerLoadImage = (element) => {
    if (!React.isValidElement(element)) {
        return element;
    }
    const children = element.props.children;
    const props = {};
    if (children !== undefined) {
        props.children = React.Children.map(children, eagerLoadImage);
    }
    if (element.type === "img") {
        props.loading = "eager";
    }
    else if (typeof element.type !== "string" &&
        element.type !== React.Fragment) {
        props.disableLazy = true;
    }
    return React.cloneElement(element, props);
};
const ImageBox = ({ image, isUniqueRow }) => {
    const imageWrapperRef = React.useRef(null);
    const [uniqueRowHeight, setUniqueRowHeight] = React.useState(`${BIG_IMAGE_HEIGHT}px`);
    const eagerImage = eagerLoadImage(image);
    // Update the height of the image wrapper based on the rendered size of the image
    React.useEffect(() => {
        if (!isUniqueRow) {
            return;
        }
        const wrapper = imageWrapperRef.current;
        if (!wrapper) {
            return;
        }
        const updateHeightFromRenderedSize = () => {
            const visual = wrapper.firstElementChild ?? wrapper;
            const { width, height } = visual.getBoundingClientRect();
            if (width > 0 && height > 0) {
                setUniqueRowHeight(width > height ? "22px" : `${BIG_IMAGE_HEIGHT}px`);
            }
        };
        updateHeightFromRenderedSize();
        const resizeObserver = typeof ResizeObserver !== "undefined"
            ? new ResizeObserver(updateHeightFromRenderedSize)
            : null;
        if (resizeObserver) {
            resizeObserver.observe(wrapper);
        }
        const visual = wrapper.firstElementChild;
        const imageElement = visual instanceof HTMLImageElement ? visual : null;
        if (imageElement && !imageElement.complete) {
            imageElement.addEventListener("load", updateHeightFromRenderedSize);
        }
        return () => {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
            if (imageElement) {
                imageElement.removeEventListener("load", updateHeightFromRenderedSize);
            }
        };
    }, [image, isUniqueRow]);
    return (_jsx(Box, { ref: imageWrapperRef, sx: {
            width: isUniqueRow ? "auto" : `${SMALL_IMAGE_HEIGHT}px`,
            height: isUniqueRow ? uniqueRowHeight : `${SMALL_IMAGE_HEIGHT}px`,
            "& img": {
                height: "auto",
                maxHeight: isUniqueRow ? uniqueRowHeight : `${SMALL_IMAGE_HEIGHT}px`,
            },
        }, children: eagerImage }));
};
export default ImageBox;
